<template>
  <div class="home">
    <Misc/>
  </div>
</template>

<script>
// @ is an alias to /src
import Misc from '@/components/Misc.vue'
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'misc',
  mixins: [getTeamsMixin],
  components: {
    Misc
  },
  created() {
    // Ensure data is loaded when this view is created
    this.ensureDataLoaded()
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>
